const PRODUCT_ID_QUERY_KEYS = [
  'productId',
  'productid',
  'product_id',
  'ProductId',
  'ProductID',
]

const isNonEmptyString = (value) => typeof value === 'string' && value.trim() !== ''

export const coalesceProductId = (...values) => {
  for (const value of values) {
    if (isNonEmptyString(value)) {
      return value.trim()
    }
  }
  return ''
}

export const getProductIdFromLocation = () => {
  if (typeof window === 'undefined') return ''

  const searchParams = new URLSearchParams(window.location.search)
  for (const key of PRODUCT_ID_QUERY_KEYS) {
    const value = searchParams.get(key)
    if (isNonEmptyString(value)) {
      return value.trim()
    }
  }

  return ''
}

export const resolveCampaignIdFromProductId = async ({ salesforce, productId }) => {
  if (!isNonEmptyString(productId)) return ''
  if (!salesforce) {
    throw new Error('Salesforce n\'est pas initialise pour resoudre le productId')
  }

  const campaign = await salesforce.getCampaign(productId.trim())
  return campaign?.Id || ''
}
